import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { PortalEventScope, useGetAuthenticatedPortalSourcingEventsQuery } from "../../../../autogen/bff-api";
import { displayDateWithTime } from "../../../../common/formatting/displayDateWithTime";
import { momentLocaleFor } from "../../../../common/formatting/i18nFormatters";
import { urls } from "../../../../urls";
import { HomePanel } from "./HomePanel";
import { MutedCell, PanelRow, PanelTable, TitleCell } from "./PanelTable";

const DISPLAY_LIMIT = 6;

export const InvitationsPanel = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const locale = momentLocaleFor(i18n.language);

  const { data, isLoading, isError } = useGetAuthenticatedPortalSourcingEventsQuery({
    scope: PortalEventScope.ActiveInvitations,
    limit: DISPLAY_LIMIT,
  });
  const events = data?.events ?? [];

  return (
    <HomePanel
      titleKey="My invitations"
      seeAllTo={urls.v2.supplier.invitations}
      isLoading={isLoading}
      isError={isError}
      isEmpty={events.length === 0}
      emptyKey="No invitations right now"
    >
      <PanelTable headers={[t("Title"), t("Buyer"), t("Deadline")]}>
        {events.map((event) => (
          <PanelRow key={event.id} onClick={() => navigate(urls.v2.supplier.procurement.go(event.id))}>
            <TitleCell title={event.title || t("Untitled")} />
            <MutedCell>{event.buyerName}</MutedCell>
            <MutedCell>
              {event.bidSubmissionDeadline ? displayDateWithTime(event.bidSubmissionDeadline, null, locale) : "—"}
            </MutedCell>
          </PanelRow>
        ))}
      </PanelTable>
    </HomePanel>
  );
};
